import {
  StickyNewsletter,
  type StickyNewsletterProps,
} from "~/components/StickyNewsletter/StickyNewsletter";
import { Icon } from "~/ui-library";
import { Flyout } from "~/ui-library/components/Flyout/Flyout";
import { XMarkIcon } from "~/ui-library/icons";

export type StickyNewsletterFlyoutProps = StickyNewsletterProps & {
  closeFlyout: () => void;
  isShowingFlyout: boolean;
};

export const StickyNewsletterFlyout: React.FC<StickyNewsletterFlyoutProps> = ({
  closeFlyout,
  isShowingFlyout,
  ...rest
}) => (
  <Flyout
    appearance="primary"
    openFromDirection="bottom"
    isOpen={isShowingFlyout}
    showOverlay={false}
    className="border-t border-solid border-gray-300"
    flyoutClassName="bg-primary-50"
    priority="low"
  >
    <div className="mx-[auto] flex max-w-[1023px] py-s lg:py-m">
      <div className="w-full px-s md:mx-xl">
        <StickyNewsletter {...rest} />
      </div>
    </div>
    <Icon
      className="absolute right-s top-s cursor-pointer"
      onClick={closeFlyout}
      SvgIcon={XMarkIcon}
    />
  </Flyout>
);
